import { Button } from "components/Button";
import styled from "styled-components/macro";
import type { ElearningThemeInterface } from "themes/elearningInterface.theme";

export type AccessibilityButtonVariant = "side-menu" | "header";

interface Props {
  theme: ElearningThemeInterface;
  $variant: AccessibilityButtonVariant;
}

export const StyledAccessibilityMenuButton = styled(Button)<Props>`
  text-align: left;
  font-size: ${({ theme, $variant }) => ($variant === "side-menu" ? theme.font.size._14 : theme.font.size._16)};
  margin: unset;

  .content {
    display: flex;
    gap: 0rem 0.5rem;
    color: ${({ theme, $variant }: Props) => ($variant === "side-menu" ? theme.palette.neutral.white : theme.palette.neutral._400)};
  }

  svg {
    height: 1.2rem;
  }
`;
